import { RUOLI } from "~~/shared/utils/ruoli";
import amministratori from "~~/shared/menu/amministratori.json";
import tecnici from "~~/shared/menu/tecnici.json";
import utenti from "~~/shared/menu/utenti.json";
import type { VoceMenu } from "~/utils/menu";

// Il menu di navigazione di ogni ruolo sta nel codice (`shared/menu/*.json`): cambia con il rilascio per tutti, senza copie salvate nel
// browser che invecchiano. Dipende solo dal ruolo: nessuna richiesta al server.
const MENU_PER_RUOLO: Record<number, VoceMenu[]> = {
  [RUOLI.ADMIN]: amministratori,
  [RUOLI.PROPRIETARIO]: utenti,
  [RUOLI.TECNICO]: tecnici,
};

/** Menu del ruolo (0 admin, 1 cliente, 2 tecnico); vuoto se il ruolo manca o non esiste. */
export function menuDelRuolo(idRuolo: number | string | null | undefined): VoceMenu[] {
  if (idRuolo === null || idRuolo === undefined || idRuolo === "") return [];
  return MENU_PER_RUOLO[Number(idRuolo)] ?? [];
}

/** Rotta della prima voce navigabile del menu del ruolo (dove si va dopo il login); `/` se non ce n'è. */
export function primaRotta(idRuolo: number | string | null | undefined): string {
  const cerca = (voci: VoceMenu[]): string | null => {
    for (const voce of voci) {
      if (voce.route) return voce.route;
      const dentro = voce.items ? cerca(voce.items) : null;
      if (dentro) return dentro;
    }
    return null;
  };
  return cerca(menuDelRuolo(idRuolo)) ?? "/";
}
